import { gsap, ScrollTrigger } from "./gsapSetup.js";

export const initSimulationAnimation = () => {
  const section = document.querySelector(".simulation-section");
  if (!section) return;

  if (window.innerWidth >= 992) {
    const tlTop = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 60%",
        end: "+=1200",
        scrub: 2,
      },
    });

    tlTop
      .to("#path-main-pion", { strokeDashoffset: 0, duration: 1, ease: "none" })
      .to(".simulation-glow-bg", { opacity: 1, scale: 1, duration: 0.5 }, ">")
      .to(
        "#path-poziom-lewo",
        { strokeDashoffset: 0, duration: 2, ease: "none" },
        ">",
      )
      .to(
        "#path-poziom-prawo",
        { strokeDashoffset: 0, duration: 2, ease: "none" },
        "<",
      )
      .to(
        ".path-branch",
        { strokeDashoffset: 0, duration: 1, ease: "none" },
        ">",
      );

    const tlBottom = gsap.timeline({
      scrollTrigger: {
        trigger: ".simulation-lines-bottom-svg-container",
        start: "top 65%",
        end: "+=200",
        scrub: 2,
      },
    });

    tlBottom
      .to(".path-bottom-top", {
        strokeDashoffset: 0,
        duration: 1,
        ease: "none",
      })
      .to(
        ["#path-bottom-level-L", "#path-bottom-level-R"],
        { strokeDashoffset: 0, duration: 1, ease: "none" },
        ">",
      )
      .to(
        "#path-bottom-final",
        { strokeDashoffset: 0, duration: 1, ease: "none" },
        ">",
      )
      .to(".cost-glow", { opacity: 1, scale: 1, duration: 0.8 }, ">")
      .to(".simulation-glow-bg-2", { opacity: 1, scale: 1.3, duration: 1 });
  } else {
    const mobLines = [
      "#line-mob-1",
      "#line-mob-2",
      "#line-mob-3",
      "#line-mob-4",
    ];

    mobLines.forEach((id) => {
      const line = document.querySelector(id);
      if (!line) return;

      const container = line.closest(".text-center");
      const glow = container
        ? container.querySelector(".simulation-glow-bg")
        : null;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: id,
          start: "top 90%",
          end: "bottom 55%",
          scrub: 1,
        },
      });

      tl.to(id, { strokeDashoffset: 0, duration: 1 });

      if (glow) {
        tl.to(
          glow,
          {
            opacity: 1,
            scale: 1.2,
            duration: 0.5,
          },
          "<",
        );
      }
    });

    const tlMobBottom = gsap.timeline({
      scrollTrigger: {
        trigger: ".simulation-lines-bottom-svg-container",
        start: "top 95%",
        end: "bottom 70%",
        scrub: 1,
      },
    });

    tlMobBottom
      .to("#mob-bottom-pion-1", { strokeDashoffset: 0, duration: 1 })
      .to(
        ["#mob-bottom-L", "#mob-bottom-R"],
        { strokeDashoffset: 0, duration: 2 },
        ">",
      )
      .to(
        ["#mob-final-L", "#mob-final-R"],
        { strokeDashoffset: 0, duration: 1.5 },
        ">",
      )
      .to(
        ".exploitation-box .simulation-glow-bg-2",
        {
          opacity: 1,
          scale: 1.1,
          duration: 1,
        },
        "-=2",
      );
  }
};
